// Fixed 4-platform form (no add/remove rows) for a single current value per
// platform - reused for both PreflightSettings.outstanding_bids and
// .misc_bank_cost (structurally identical, see columnLabel prop). Ports
// reporting-hub's OutstandingBidsForm.tsx, MINUS its read-only "+ From
// Pending Loans" / "+ From Manual Exclusions" breakdown columns: those come
// from calculationResult.excluded_loans / .manual_exclusions, which aren't
// wired into this port (CalculationResultsView only receives
// `calculationResult`, and this dialog is a general Settings editor, not
// scoped to a specific attempt) - noted as an intentionally-simplified area
// in the handback report, easy to add later by threading
// calculationResult.excluded_loans/manual_exclusions down from
// CalculationResultsView.

import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { PLATFORM_ORDER, titleCasePlatform } from './calcFormat';

const OutstandingBidsForm = ({ values, onChange, columnLabel = 'Outstanding Bids' }) => {
  const updatePlatform = (platform, amount) => {
    onChange({ ...values, [platform]: amount });
  };

  return (
    <div className="cr-table-frame" style={{ maxWidth: '22rem' }}>
      <table className="cr-data-table cr-form-table">
        <thead>
          <tr>
            <th>Originator</th>
            <th className="cr-right">{columnLabel}</th>
          </tr>
        </thead>
        <tbody>
          {PLATFORM_ORDER.map((platform) => (
            <tr key={platform}>
              <td>{titleCasePlatform(platform)}</td>
              <td className="cr-right">
                <InputNumber
                  value={values[platform] ?? 0}
                  onValueChange={(e) => updatePlatform(platform, e.value || 0)}
                  mode="decimal"
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  inputStyle={{ width: '9rem', textAlign: 'right', fontSize: '0.82rem' }}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OutstandingBidsForm;
